import React, { useEffect } from 'react';
import BienForm from '../components/Forms/BienForm';
import { DialogTitle, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import MyTable from '../components/MyTable';
import { TableAction, TableHeader } from '../constants/interfaces';
import { Bien } from '../models/models';
import { ButtonType } from '../constants/enums';
import { fetchBienData, setFilters, setSelectedBien } from '../reduxStore/BienSlice';
import { labels } from '../constants/labels';
import { AppDispatch } from '../reduxStore/Store';
import BienFilters from '../components/Filters/BienFilters';
import { useDialog } from '../components/DialogComponent';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AppPage from '../components/layout/AppPage';
import AppSurface from '../components/layout/AppSurface';
import AppPageHeader from '../components/layout/AppPageHeader';

const GestionBien: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { bienData, filters, total, loading, error, successMessage } = useSelector((state: any) => state.BienSlice);
    const selectedBien = useSelector((state: any) => state.BienSlice.selectedBien);

    const [FormDialog, openDialog, closeDialog] = useDialog({
        dialogProps: { maxWidth: 'md', fullWidth: true }
    });

    const handleCancel = () => {
        closeDialog();
        dispatch(setSelectedBien(null));
    };

    useEffect(() => {
        dispatch(fetchBienData(filters));
    }, [dispatch, filters, successMessage]);

    const headers: TableHeader<Bien>[] = [
        { key: "type", label: "Type" },
        { key: "nom", label: "Nom" },
        { key: "description", label: "Description" },
        { key: "adresse", label: "Adresse" },
        { key: "surface", label: "Surface" },
        {
            key: "proprietaire_id", label: labels.fournisseur,
            render: (row) => row.proprietaire
                ? `${row.proprietaire.nom} ${row.proprietaire.prenom}`
                : "N/A"
        },
        {
            key: "groupe_bien", label: labels.groupeBien,
            render: (row) => row.groupe_bien ? `${row.groupe_bien.nom}` : "N/A"
        },
    ];

    const tableActions: TableAction<Bien>[] = [
        {
            label: "Edit",
            callback: (bien) => {
                dispatch(setSelectedBien(bien));
                openDialog();
            },
            type: ButtonType.EDIT,
        },
    ];

    const handlePageChange = (newPage: number, newRowsPerPage: number) => {
        dispatch(setFilters({
            ...filters,
            offset: newPage * newRowsPerPage,
            limit: newRowsPerPage,
        }));
    };

    return (
        <AppPage maxWidth={false}>
            <AppPageHeader
                title={labels.gestionBiens}
                subtitle={`${total} ${labels.bien.toLowerCase()}${total > 1 ? 's' : ''}`}
                icon={<ApartmentIcon />}
                addLabel={`Ajouter un ${labels.bien}`}
                onAdd={openDialog}
            />

            {loading && <Typography color="#667085" mb={2}>Chargement...</Typography>}
            {error && <Typography color="#b42318" mb={2}>Erreur : {error}</Typography>}

            <AppSurface sx={{ mb: 2 }} padding={2}>
                <BienFilters />
            </AppSurface>

            <AppSurface>
                <MyTable
                    headers={headers}
                    data={bienData}
                    onPageChange={handlePageChange}
                    actions={tableActions}
                    totalRows={total}
                />
            </AppSurface>

            <FormDialog>
                <DialogTitle>
                    <Typography variant="h6">
                        {selectedBien ? `Modifier un ${labels.bien}` : `Ajouter un ${labels.bien}`}
                    </Typography>
                </DialogTitle>
                <BienForm onCancel={handleCancel} />
            </FormDialog>
        </AppPage>
    );
};

export default GestionBien;
